// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.common with an alias.
import Vue from "vue";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import App from "./app.vue";
import Vue2Filters from "vue2-filters";
import VueCookies from "vue-cookies";
import router from ".";
import * as config from "./shared/config/config";
import * as bootstrapVueConfig from "./shared/config/config-bootstrap-vue";
import BootstrapVueIcons from "bootstrap-vue";

import JhiItemCountComponent from "./back-office/jhipster-old/jhi-item-count.vue";
import InfiniteLoading from "vue-infinite-loading";
import AuditsService from "./back-office/jhipster-old/audits/audits.service";

import HealthService from "@/back-office/metrics/health.service";
import MetricsService from "@/back-office/metrics/metrics.service";
import ActivateService from "@/core/activate/activate.service";

import LoginService from "./core/login.service";
import AccountService from "./core/account.service";

import "../content/scss/vendor.scss";
import TranslationService from "@/shared/services/translation.service";

/* eslint-disable */
import GlobalService from "@/shared/services/global.service";

// ODO
import ActionPanelService from "@/back-office/actions/action-panel.service";
import BackOfficeService from "@/back-office/back-office.service";
import ElearningService from "@/products/e-learning/elearning.service";

import PlatformService from "@/products/platform/services/platform.service";
import ESGDashboardService from "@/products/esg/services/esg-dashboard.service";

import Dashboard360Service from "@/products/360/services/dashboard-360.service";
import HistoryService from "./shared/services/history.service";
import HierarchyService from "./products/platform/services/hierarchy.service";

import CourseChapterService from "./shared/services/course-chapter.service";
import ClientService from "./shared/services/client.service";
import EsgGameDataService from "./shared/services/esg-game-data.service";
import DiscordService from "./shared/services/discord.service";

// Charts
import VueApexCharts from "vue-apexcharts";
//Slider
import VueSlider from "vue-slider-component";
import "vue-slider-component/theme/default.css";
Vue.component("VueSlider", VueSlider);

import VueDragDrop from "vue-drag-drop";
Vue.use(VueDragDrop);

/* eslint-enable */
Vue.config.productionTip = false;
config.initVueApp(Vue);
config.initFortAwesome(Vue);
bootstrapVueConfig.initBootstrapVue(Vue);
Vue.use(BootstrapVueIcons);

// /* eslint-disable */
// import VueCompositionAPI from '@vue/composition-api';
// /* eslint-disable */
// Vue.use(VueCompositionAPI);

Vue.use(Vue2Filters);
Vue.component("font-awesome-icon", FontAwesomeIcon);
Vue.component("jhi-item-count", JhiItemCountComponent);
Vue.component("infinite-loading", InfiniteLoading);
Vue.component("apexchart", VueApexCharts);

import VueRecaptcha from "vue-recaptcha";
import GameDataService from "./shared/services/game-data.service";
import ReportDashboardService from "./products/360/services/report-dashboard.service";
import UserService from "./shared/services/user-management/user.service";
import CompanyService from "./shared/services/user-management/company.service";
import FranchiseService from "./shared/services/user-management/franchise.service";
import ParameterService from "./shared/services/user-management/parameter.service";

Vue.component("vue-recaptcha", VueRecaptcha);
const i18n = config.initI18N(Vue);
i18n.locale = "fr";
const store = config.initVueXStore(Vue);

const translationService = new TranslationService(store, i18n);
const parameterService = new ParameterService();
const loginService = new LoginService();
const accountService = new AccountService(store, translationService, parameterService, router);

router.beforeEach((to, from, next) => {
  // redirect signup (which does not exist anymore but is referenced on search engines) to Odonatech corpo website
  if (to.path == "/signup") window.location.replace("https://www.odonatech.com/");

  if (!to.matched.length) {
    next("/core/not-found");
  }

  // garde le path de coté
  sessionStorage.setItem("path", to.fullPath);

  // check authorities and if logged in
  if (to.meta && to.meta.authorities && to.meta.authorities.length > 0) {
    accountService.hasAnyAuthorityAndCheckAuth(to.meta.authorities).then((value) => {
      // if not connected, store requested url and open a login form, then redirect
      if (!value) {
        sessionStorage.setItem("requested-url", to.fullPath);
        next("");
      } else {
        next();
      }
    });
  } else {
    // no authorities needed, just proceed
    next();
  }
});

Vue.use(VueCookies);
// Vue.use(VueGtag);

/* eslint-disable */
new Vue({
  el: "#app",
  components: { App },
  template: "<App/>",
  router,
  provide: {
    loginService: () => loginService,
    activateService: () => new ActivateService(),
    auditsService: () => new AuditsService(),

    healthService: () => new HealthService(),

    metricsService: () => new MetricsService(),
    translationService: () => translationService,
    courseChapterService: () => new CourseChapterService(),
    clientService: () => new ClientService(),
    historyService: () => new HistoryService(),
    esgGameDataService: () => new EsgGameDataService(),
    gameDataService: () => new GameDataService(),
    discordService: () => new DiscordService(),

    accountService: () => accountService,

    actionPanelService: () => new ActionPanelService(),
    backOfficeService: () => new BackOfficeService(store),
    elearningService: () => new ElearningService(),

    esgDashboardService: () => new ESGDashboardService(),

    globalService: () => new GlobalService(),
    parameterService: () => new ParameterService(),

    platformService: () => new PlatformService(),

    dashboard360Service: () => new Dashboard360Service(),
    reportDashboardService: () => new ReportDashboardService(),
    userService: () => new UserService(),
    hierarchyService: () => new HierarchyService(),
    companyService: () => new CompanyService(),
    franchiseService: () => new FranchiseService(),
  },
  i18n,
  store,
});

export default store;
